<template>
  <div class="ordermade">
    <AppHeader />
    <TheBtoPanel />
    <AppFooter />
  </div>
</template>

<script>
// @ is an alias to /src
import TheBtoPanel from "@/components/BtoPanel/TheBtoPanel.vue";
import AppHeader from "@/components/AppHeader.vue";
import AppFooter from "@/components/AppFooter.vue";

export default {
  name: "Home",
  components: {
    TheBtoPanel,
    AppHeader,
    AppFooter,
  },
};
</script>

<style scoped lang="stylus">
.ordermade
  background-color: white
</style>
